import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { ApolloModel } from './ApolloModel';
import { UserModel } from '../../auth/core/_models';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
  currentUser?: UserModel;
};

const ApolloWidget: React.FC<Props> = ({ className, currentUser }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className='' style={{ padding: 0 }}>
      <a className={`hoverable`} onClick={() => setModalShow(true)}>
        <img 
          src={toAbsoluteUrl('/media/partner/apollo.png')} 
          width="100%" 
          alt='Apollo Health Checkup' 
          className='card-p-5 shadow' 
          style={{ borderRadius: 8 }} 
        />
      </a>
      <ApolloModel show={modalShow} handleClose={() => setModalShow(false)} currentUser={currentUser} />
    </div>
  );
};

export { ApolloWidget };
